import axios from "axios";
import { API_HOST } from "@/core/variables";
import { CreateMember, UpdateMember, UpdateOwner } from "@/model";

class MemberRepository {
    create = async (agentId: number, form: CreateMember) => {
        return axios
            .post(`${API_HOST}/v1/agents/${agentId}/members`, {
                ...form
            });
    };
    
    find = async (agentId: number) => {
        return axios
            .get(`${API_HOST}/v1/agents/${agentId}/members`)
            .then((response) => Promise.resolve(response))
            .catch((error) => Promise.reject(error));
    };

    delete  = async (agentId: number, memberId: string) => {
        return axios.delete(`${API_HOST}/v1/agents/${agentId}/members/${memberId}`);
    };

    update = async (agentId: number, memberId: string, form: UpdateMember) => {
        return axios.put(`${API_HOST}/v1/agents/${agentId}/members/${memberId}`, {
            ...form
        });
    };
    
    updateOwner = async (agentId: number, form: UpdateOwner) => {
        return axios.put(`${API_HOST}/v1/agents/${agentId}/owner`, {
            ...form
        });
    };
}

const memberRepository = new MemberRepository();
export default memberRepository;

